module.exports = __webpack_public_path__ + "img/Yeti-Logo.410bbfac.png";